<template>
    <v-form ref="form" class="d-flex align-center" style="width: 100%" v-model="valid">
        <div class="mr-3">
            <v-text-field
                v-model="fields.search"
                @change="changed('search')"
                append-icon="mdi-magnify"
                filled
                label="Buscar"
                hide-details
                clearable
            ></v-text-field>
        </div>
        <div class="mr-3">
            <v-select
                :items="isActiveList"
                filled
                hide-details
                label="Estado"
                v-model="fields.is_active"
                :disabled="loading"
                @change="changed('is_active')"
                />
        </div>
        <div class="mr-3"> <!--v-show="showMaster"-->
            <v-select
                :items="masterList"
                :loading="isLoadingMasterList"
                :disabled="isLoadingMasterList || !showMaster"
                item-text="name"
                item-value="id"
                label="Master"
                @change="changed('master_id')"
                v-model="fields.master_id"
                hide-details
                filled
                >
            </v-select>
        </div>
        <div class="d-flex">
            <v-btn text class="mr-3" :disabled="loading" @click="reset()">Reiniciar Filtros</v-btn>
            <v-btn color="primary" :disabled="loading" :loading="loading" @click="search()"><v-icon>mdi-magnify</v-icon>Buscar</v-btn>
        </div>
    </v-form>
</template>

<script>
import Search from '@mixins/search';

import MasterService from '@services/comercio/MasterService';

export default {
    mixins: [Search],
    data: function ()  {
        return {
            isActiveList: [
                {
                    text: 'Todos',
                    value: null,
                },
                {
                    text: 'Activos',
                    value: true,
                },
                {
                    text: 'Inactivos',
                    value: false,
                }
            ],

            defaultFields: {
                search: null,
                master_id: null,
                is_active: null,
            },

            isLoadingMasterList: false,
            showMaster: true,
            masterList: [],
        }
    },
    /*created: function () {
        this.getMasterList();
    },*/
    methods: {
        getMasterList: function () {
            this.isLoadingMasterList = true;

            this.masterList = [];

            MasterService
                .getList({ is_active: true })
                .then(({ masterList }) => {
                    if (masterList.length == 1) 
                    {
                        this.fields.master_id = masterList[0].id;
                        this.showMaster = false;
                    }
                    this.masterList = [{id: null, name: 'Todos'},...masterList];
                })
                .finally(() => this.isLoadingMasterList = false);
        },
    },
    watch: {
        'fields.master_id': function () {
            this.showComercializadora = true;
            if (!this.fields.master_id) this.getMasterList();
        },
    }
}
</script>

<style>

</style>